import { toast } from "react-toastify"
import { translate } from "./langUtils"

export const successToast = (message: string) => 
  toast.success(String(translate(message) || message))

export const errorToast = (message: string) => 
  toast.error(String(translate(message) || message))

export const warningToast = (message: string) => 
  toast.warning(String(translate(message || "")))

export const infoToast = (message: string) => 
  toast.info(String(translate(message) || message)) 